import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { debounce } from 'lodash-es';
import keys from './keys';
import customerKeys from '../customer/keys';
import userKeys from '../user/keys';
import featuresKeys from '../features/keys';
import useApiMutation from '../useApiMutation';

const useCreateEpisode = () => {
  const queryClient = useQueryClient();
  const { networkId } = useParams();

  const mutation = useApiMutation({
    getRequestUrl: ({ showId }) => `/shows/${showId}/episodes`,
    method: 'POST',
    onSuccess: (newEpisodeData) => {
      queryClient.setQueryData(
        keys(newEpisodeData.show).episode(newEpisodeData._id),
        newEpisodeData
      );
      queryClient.invalidateQueries(keys(newEpisodeData.show).episodes);
      queryClient.invalidateQueries(customerKeys.customer);
      queryClient.invalidateQueries(userKeys.me);
      queryClient.invalidateQueries(
        featuresKeys.list({
          networkId,
          showId: newEpisodeData.show,
        })
      );
    },
  });

  // this makes sure that the first call is immediate and all the other calls during debounce time are ignored
  const debouncedCreateEpisode = debounce(
    (...args) => {
      if (!mutation.isLoading) {
        mutation.mutate(...args);
      }
    },
    1000,
    { leading: true, trailing: false }
  );

  return {
    createEpisode: debouncedCreateEpisode,
    isCreateEpisodeLoading: mutation.isLoading,
    isCreateEpisodeError: mutation.isError,
    isCreateEpisodeSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useCreateEpisode;
